import React from "react";

import { css } from "@compiled/react";

export interface HeadingProps {
    text: string;
    wordWrap?: boolean;
}

export const Heading = (props: HeadingProps) => {
    const { text, wordWrap } = props;

    return (
        <h1
            css={[
                css({
                    marginBlock: 0
                }),
                wordWrap &&
                    css({
                        wordWrap: "break-word",
                        hyphens: "auto"
                    })
            ]}
        >
            {text}
        </h1>
    );
};
